import React, { useEffect, useState } from 'react';
import Main from '../Main';
import { Box } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { clearData, allProductDetails } from '../../../Redux/ProductRedux';
import DataTable from '../Table/DataTable';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import BackupTableIcon from '@mui/icons-material/BackupTable';
import { productColumns } from '../Table/TableColumns';
import AddProduct from './AddProduct';
import { toast } from 'react-toastify';

const ManageProducts = () => {
  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem('user'));

  const { getProductDetails, newProduct, statusUpdate } = useSelector(
    (state) => state.productRedux
  );

  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    const fetchProductDetails = async () => {
      try {
        const userId = user.userId;
        await dispatch(allProductDetails(userId));
      } catch (error) {
        toast.error('Failed to fetch product details');
      }
    };
    fetchProductDetails();
  }, [dispatch, newProduct, statusUpdate]);

  const handleButtonClick = () => {
   dispatch(clearData());
    setShowForm((prevShowForm) => !prevShowForm);
  };

  const rows = Array.isArray(getProductDetails)
    ? getProductDetails.map((product, index) => {
        return {
          id: product._id,
          sNo: index + 1,
          productName: product.productName,
          images: product.images,
          underCategory: product.underCategory,
          priceAndQuantity: product.priceAndQuantity,
          description: product.description,
          sku: product.sku,
          status: product.status,
          isFeatured: product.isFeatured === true ? 'Yes' : 'No',
          createdBy: product.createdBy,
          updatedAt: product.updatedAt,
          isActive: product.isActive === true ? 'Yes' : 'No',
        };
      })
    : [];

  return (
    <Main>
      <Box component='main' sx={{ flexGrow: 1, p: 3 }}>
        <div className='container border p-4'>
          <div className='row'>
            {user.role === 'seller' && (
              <div className='col-12 text-end'>
                <button
                  type='button'
                  className='btn btn-success'
                  onClick={handleButtonClick}
                >
                  {showForm ? (
                    <BackupTableIcon style={{ marginRight: '5px' }} />
                  ) : (
                    <AddCircleIcon style={{ marginRight: '5px' }} />
                  )}
                  {showForm ? 'Show Table' : 'Add Product'}
                </button>
              </div>
            )}
            {showForm ? (
              <AddProduct setShowForm={setShowForm} />
            ) : (
              <div className='row mt-3'>
                <div className='col-md-12'>
                  <DataTable
                    setShowForm={setShowForm}
                    columns={productColumns}
                    rows={rows}
                    tableType='manageProducts'
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </Box>
    </Main>
  );
};

export default ManageProducts;
